import React, { useMemo } from 'react';
import Video from 'components/video';
import videoSourceUtils from 'js/video-source-utils';
import useBreakpoints from 'hooks/use-breakpoints';
import PropTypes from 'prop-types';
import cn from 'classnames';

const VideoBlock = ({ heading, video, place }) => {
  const { isDesktop } = useBreakpoints(true);

  const videoOrientation = useMemo(() => {
    const { mobileVideo, desktopVideo } = videoSourceUtils.getVideoSourceData(
      video.landscapeSource,
      video.portraitSource
    );
    const currentVideo = isDesktop ? desktopVideo : mobileVideo;

    return currentVideo.orientation;
  }, [video, isDesktop]);

  return video ? (
    <div
      className={cn('video-block', {
        [`video-block_in-${place}`]: place,
      })}
    >
      <div className="video-block__container">
        {heading && <h2 className="video-block__heading">{heading}</h2>}
        <Video
          {...video}
          imageSettings={{
            className: `image_size_video-block-orientation-${videoOrientation}`,
          }}
        />
      </div>
    </div>
  ) : null;
};

VideoBlock.propTypes = {
  heading: PropTypes.string,
  video: PropTypes.exact(Video.propTypes),
  place: PropTypes.string,
};

export default VideoBlock;
